/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgSelectIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    viewBox="0 0 21 21"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <rect width={20} height={20} x={0.75} y={0.056} fill="currentColor" rx={10} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m16.414 7.806-6.207 6.207a1 1 0 0 1-1.414 0l-3.707-3.707L6.5 8.892l3 3 5.5-5.5 1.414 1.414Z"
      clipRule="evenodd"
    />
  </svg>
)
const Memo = memo(SvgSelectIcon)
export default Memo
